import React from 'react';
//@ts-ignore
import { nanoid } from 'nanoid/non-secure';
var RegionIcon = function RegionIcon() {
  var id = nanoid();
  var linearGradientId0 = "paint0_linear_".concat(id);
  var linearGradientId1 = "paint1_linear_".concat(id);
  var linearGradientId2 = "paint2_linear_".concat(id);
  var linearGradientId3 = "paint3_linear_".concat(id);
  return /*#__PURE__*/React.createElement("svg", {
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    y: "0.200012",
    width: "25.6",
    height: "25.6",
    rx: "4",
    fill: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85406 10.1993C7.85406 7.40166 10.1741 5.16254 13 5.16254C15.8259 5.16254 18.146 7.40166 18.146 10.1993C18.146 12.1667 16.8625 13.9071 15.7225 15.0827C15.1372 15.6864 14.5543 16.1772 14.1187 16.5167C13.9003 16.687 13.7175 16.8203 13.5879 16.912C13.5231 16.9578 13.4716 16.9933 13.4354 17.0178L13.393 17.0463L13.381 17.0543L13.3774 17.0567L13.3762 17.0575C13.3762 17.0575 13.3754 17.058 13 16.4837L12.6243 17.0578L12.6227 17.0567L12.619 17.0543L12.607 17.0463L12.5646 17.0178C12.5285 16.9933 12.4769 16.9578 12.4121 16.912C12.2826 16.8203 12.0998 16.687 11.8814 16.5167C11.4457 16.1772 10.8628 15.6864 10.2775 15.0827C9.13753 13.9071 7.85406 12.1667 7.85406 10.1993ZM10.5986 10.3095C10.5986 8.98319 11.6737 7.90801 13 7.90801C14.3263 7.90801 15.4015 8.98319 15.4015 10.3095C15.4015 11.6357 14.3263 12.7109 13 12.7109C11.6737 12.7109 10.5986 11.6357 10.5986 10.3095Z",
    fill: "url(#".concat(linearGradientId0, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6243 17.0578C12.8524 17.2068 13.1481 17.2065 13.3762 17.0575L13 16.4837C12.6247 17.058 12.6243 17.0578 12.6243 17.0578Z",
    fill: "url(#".concat(linearGradientId1, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93335 18.3353C4.93335 17.1942 6.76394 16.2068 9.42624 15.7327C9.50348 15.8157 9.58047 15.8966 9.65694 15.9755C10.3757 16.7167 11.0914 17.3193 11.6264 17.7363C11.8945 17.9453 12.119 18.1091 12.2781 18.2216C12.3577 18.2779 12.421 18.3215 12.4654 18.3516L12.5174 18.3866L12.5322 18.3964L12.5366 18.3994L12.5387 18.4007C12.8187 18.5837 13.1809 18.584 13.4609 18.401L13 17.6957C13.4609 18.401 13.4619 18.4003 13.4619 18.4003L13.4679 18.3964L13.4826 18.3866L13.5347 18.3516C13.579 18.3215 13.6424 18.2779 13.7219 18.2216C13.881 18.1091 14.1055 17.9453 14.3737 17.7363C14.9086 17.3193 15.6243 16.7167 16.3431 15.9755C16.4196 15.8966 16.4966 15.8157 16.5738 15.7327C19.2361 16.2068 21.0667 17.1942 21.0667 18.3353C21.0667 19.9382 17.4551 21.2376 13 21.2376C8.54492 21.2376 4.93335 19.9382 4.93335 18.3353Z",
    fill: "url(#".concat(linearGradientId2, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5387 18.4007C12.5387 18.4007 12.5391 18.401 13 17.6957L12.5387 18.4007Z",
    fill: "url(#".concat(linearGradientId3, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: linearGradientId0,
    x1: "13",
    y1: "5.16254",
    x2: "13",
    y2: "21.2376",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#4C65ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: linearGradientId1,
    x1: "13",
    y1: "5.16254",
    x2: "13",
    y2: "21.2376",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#4C65ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: linearGradientId2,
    x1: "13",
    y1: "5.16254",
    x2: "13",
    y2: "21.2376",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#4C65ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: linearGradientId3,
    x1: "13",
    y1: "5.16254",
    x2: "13",
    y2: "21.2376",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#4C65ED"
  }))));
};
export default RegionIcon;